import { render, staticRenderFns } from "./FormYesNo.vue?vue&type=template&id=ba179b5a"
import script from "./FormYesNo.vue?vue&type=script&lang=js"
export * from "./FormYesNo.vue?vue&type=script&lang=js"
import style0 from "./FormYesNo.vue?vue&type=style&index=0&id=ba179b5a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports